import React from 'react';
import { Helmet } from 'react-helmet';
import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import NotificationSettingsModal from '../../components/notifications/Settings';
import BackToTop from 'components/BackToTop/BackToTop';
import Footer from 'components/Footer/Footer';
import FAQHeader from '../../components/FAQ/Header';
import FAQComponent from '../../components/FAQ/FAQComponent';

const FAQ: React.FC = () => {
  return (
    <>
      <ScrollTopOnMount />
      <Helmet defer={false} title="FAQ" />

      <NotificationSettingsModal />

      <FAQHeader />
      <FAQComponent />

      <BackToTop />
      <Footer />
    </>
  );
};

export default FAQ;
